import { left, right } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import Logo from 'domain/entity/logo';
import ReadLogoClient from 'use-case/logos/read/readLogosClient';

const readLogosApiClient = (httpClient: httpClientFunction, baseUrl: string): ReadLogoClient => () => {
    const urlWithoutApiv3 = baseUrl.replace('/api-v3', '');
    return httpClient(`${urlWithoutApiv3}/reports/logos`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLogos)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));
};

const asLogos = (logosJson: LogoJson[]): Logo[] => logosJson.map((logo) => new Logo(logo.id, logo.name, logo.imgResourceKey));

export type LogoJson = {
    id: string;
    name: string;
    imgResourceKey: string;
};

export default readLogosApiClient;
